import { render, staticRenderFns } from "./TagBox.vue?vue&type=template&id=24c74bc5&scoped=true&"
import script from "./TagBox.vue?vue&type=script&lang=js&"
export * from "./TagBox.vue?vue&type=script&lang=js&"
import style0 from "./TagBox.vue?vue&type=style&index=0&id=24c74bc5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c74bc5",
  null
  
)

export default component.exports